import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';

import { CmsBlogHeaderSearchComponentClass } from 'lib/components/cms/blog/cms-blog-header-search-component.class';
import { CmsService } from 'lib/services/cms.service';
import { RouterService } from 'lib/services/router.service';
import { calculateReadingTime } from 'lib/tools';

@Component({
    selector: 'app-cms-blog-header-search',
    templateUrl: './cms-blog-header-search.component.html',
    styleUrls: ['./cms-blog-header-search.component.scss'],
    standalone: false,
})
export class CmsBlogHeaderSearchComponent extends CmsBlogHeaderSearchComponentClass implements OnInit {
    calculateReadingTime: (entry: any) => string;
    constructor(
        @Inject(PLATFORM_ID) platformId: Object,
        @Inject('environment') environment: any,
        cmsService: CmsService,
        routerService: RouterService
    ) {
        super({ dependencies: { platformId, environment, cmsService, routerService } });
        this.calculateReadingTime = calculateReadingTime;
    }
}
